import React from 'react'

import {Theme, Typography, TypographyProps} from '@mui/material'
import LinearProgress, {LinearProgressProps} from '@mui/material/LinearProgress'
import {makeStyles} from 'tss-react/mui'

export type ProgressBarProps = {
  title?: string
  typographyProps?: TypographyProps
  progressColor: {main: string; light?: string}
} & LinearProgressProps

const useStyles = makeStyles<{progressColor: {main: string; light?: string}}>()(
  (theme: Theme, props) => ({
    colorSecondary: {
      backgroundColor: props.progressColor.light,
      borderRadius: 32,
      height: 9,
    },
    barColorSecondary: {
      backgroundColor: props.progressColor.main,
    },
  })
)

const ProgressBar = ({
  value,
  color,
  title,
  typographyProps,
  progressColor,
  ...rest
}: ProgressBarProps) => {
  const {classes} = useStyles({progressColor})

  return (
    <>
      {title && (
        <Typography variant={'subtitle2'} mb={2} textAlign={'center'}>
          {title}
        </Typography>
      )}
      <LinearProgress
        variant='determinate'
        value={value}
        color={color || 'secondary'}
        classes={{...classes}}
        {...rest}
      />
    </>
  )
}

ProgressBar.defaultValue = {
  value: 0,
}

export default ProgressBar
